import { BoxDetailAlarmProps } from '@/box/interface'
import { Column } from '@/shared/Column'
import { TemplateAlarmTable } from '@/template/alarm/table'
import { getFormatMessage } from '@/utils/utils'
import { Badge, Space, Switch } from 'antd'
import React, { useState } from 'react'

export const BoxDetailAlarm: React.FC<BoxDetailAlarmProps> = (
  props: BoxDetailAlarmProps
) => {
  const { detailItem, contactTemplate, onAlarmPushStatusChange } = props
  const [loading, setLoading] = useState<boolean>(false)
  const formatMessage = getFormatMessage()
  const columns: Column[] = [
    {
      index: 1,
      override: false,
      title: formatMessage({ id: 'app.box.detail.template.alarm.status' }),
      render: (text: any, record: any) => {
        return (
          <span>
            <Badge status='success' />
            {formatMessage({ id: 'app.alarmStatus.0' })}
          </span>
        )
      }
    },
    {
      index: 5,
      hidden: true
    }
  ]

  const handleAlarmPushStatusChange = async (checked?: boolean) => {
    if (onAlarmPushStatusChange) {
      try {
        setLoading(true)
        await onAlarmPushStatusChange(checked ? 1 : 0)
      } finally {
        setLoading(false)
      }
    }
  }

  return (
    <div>
      <Space style={{ marginBottom: 5 }}>
        <span>
          {formatMessage({ id: 'app.box.detail.template.alarm.pushStatus' })}
        </span>
        <Switch
          checkedChildren={formatMessage({
            id: 'app.box.detail.variable.pushStatus.on'
          })}
          unCheckedChildren={formatMessage({
            id: 'app.box.detail.variable.pushStatus.off'
          })}
          onChange={handleAlarmPushStatusChange}
          loading={loading}
          disabled={detailItem?.connectionState !== 1}
          checked={detailItem?.enableAlarmPush === 1}
        />
      </Space>
      <TemplateAlarmTable
        columns={columns}
        plcs={contactTemplate?.plcs}
        variables={contactTemplate?.variables}
        data={contactTemplate?.alarms}
      />
    </div>
  )
}
